type ToastType = 'success' | 'error';
type Listener = (type: ToastType, message: string) => void;

let _listener: Listener | null = null;

export const toast = {
  success: (message: string) => _listener?.('success', message),
  error: (message: string) => _listener?.('error', message),
  _subscribe: (fn: Listener) => { _listener = fn; },
  _unsubscribe: () => { _listener = null; },
};
